import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'

export default () => (
    <DataView module={Constants.module.SDD} object={Constants.donnee.flag}/>
)



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/SuiviDossier/Flag/index.js